import { Text } from '@applane/react-core-components';
import React from 'react';
import { Form } from '../../../app-components/form/Form';
import { showAllDetailsUri } from '../../../Queries/uciReportQuery';
import vars from '../../../theme/vars';
const modifyDateView = (value) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];
  const d = new Date(value);
  const day = d.getDate();
  const month = monthNames[d.getMonth()];
  const year = d.getFullYear();

  return `${month} ${day} ${year}`;
};

const checkField = ({ navigation, fieldName, isDate = false }) => {
  const ele = navigation?.state?.params?.item[fieldName];

  if (ele) {
    if (isDate) {
      return (
        <Text
          style={{
            fontFamily: 'Mulish-Regular',
            letterSpacing: '0em',
            fontSize: 20,
            textAlign: 'left',
            color: 'black',
          }}>
          {modifyDateView(ele)}
        </Text>
      );
    } else {
      return (
        <Text
          style={{
            fontFamily: 'Mulish-Regular',
            letterSpacing: '0em',
            fontSize: 20,
            textAlign: 'left',
            color: 'black',
          }}>
          {ele}
        </Text>
      );
    }
  } else {
    return (
      <Text
        style={{
          fontFamily: 'Mulish-Regular',
          letterSpacing: '0em',
          fontSize: 20,
          textAlign: 'left',
          color: 'grey',
        }}>
        N.A.
      </Text>
    );
  }
};

const ViewReport = (props) => {
  return (
    <Form
      type="standard"
      uri={showAllDetailsUri}
      closeView={1}
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          //appraisal details section
          {
            columnsPerRow: 3,
            fieldVariant: 'filled',
            label: 'Appraisal Details',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: '1px solid' + vars.colors.grey.color2,
            },
            groups: [
              {
                columns: [
                  {
                    // type: 'text',
                    // field: 'repairOrderNumber',
                    label: 'Repair Order #',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'repairOrderNumber',
                      }),
                  },
                  {
                    // type: 'date',
                    // field: 'openDate',
                    label: 'Repair Order Open Date',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'openDate',
                        isDate: true,
                      }),
                  },
                  {
                    type: 'text',
                    label: 'Price Range',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'finalrange',
                      }),
                  },
                  {
                    //type: 'text',
                    //field: 'rmbp',
                    label: 'Original Wholesale Value',
                    render: ({ navigation }) => (
                      <Text
                        style={{
                          fontFamily: 'Mulish-Regular',
                          letterSpacing: '0em',
                          fontSize: 20,
                          textAlign: 'left',
                        }}>
                        {navigation?.state?.params?.item?.rmbp
                          ? ` $ ${parseInt(
                              navigation?.state?.params?.item?.rmbp,
                            )} `
                          : null}
                      </Text>
                    ),
                  },
                  {
                    //type: 'text',
                    //field: 'ruleSpread',
                    label: 'Spread',
                    render: ({ navigation }) => (
                      <Text
                        style={{
                          fontFamily: 'Mulish-Regular',
                          letterSpacing: '0em',
                          fontSize: 20,
                          textAlign: 'left',
                        }}>
                        {navigation?.state?.params?.item?.ruleSpread
                          ? `${navigation?.state?.params?.item?.ruleSpread} % `
                          : null}
                      </Text>
                    ),
                  },
                  {
                    //type: 'text',
                    //field: 'ruleEnhancement',
                    label: 'Enhancement',
                    render: ({ navigation }) => (
                      <Text
                        style={{
                          fontFamily: 'Mulish-Regular',
                          letterSpacing: '0em',
                          fontSize: 20,
                          textAlign: 'left',
                        }}>
                        {navigation?.state?.params?.item?.ruleEnhancement
                          ? `${navigation?.state?.params?.item?.ruleEnhancement} % `
                          : null}
                      </Text>
                    ),
                  },
                ],
              },
            ],
          },

          //dealer details section
          {
            columnsPerRow: 3,
            fieldVariant: 'filled',
            label: 'Dealer Details',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: '1px solid' + vars.colors.grey.color2,
            },
            groups: [
              {
                columns: [
                  {
                    // type: 'text',
                    // field: 'dealerDMS',
                    label: 'Dealer Management System',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'dealerDMS',
                      }),
                  },
                  {
                    // type: 'text',
                    // field: 'dealerName',
                    label: 'Dealer Name',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'dealerName',
                      }),
                  },
                ],
              },
            ],
          },

          //customer details section
          {
            columnsPerRow: 3,
            fieldVariant: 'filled',
            label: 'Customer',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: '1px solid' + vars.colors.grey.color2,
            },
            groups: [
              {
                columns: [
                  {
                    type: 'text',
                    label: 'Name',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'customerName',
                      }),
                  },
                  {
                    type: 'text',
                    label: 'Email',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'customerEmail',
                      }),
                  },
                  {
                    type: 'text',
                    label: 'Contact Number',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'customerContactNumber',
                      }),
                  },
                ],
              },
            ],
          },

          //vehicle details section
          {
            columnsPerRow: 3,
            fieldVariant: 'filled',
            label: 'Vehicle Details',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: '1px solid' + vars.colors.grey.color2,
            },
            groups: [
              {
                columns: [
                  {
                    // type: 'text',
                    // field: 'vin',
                    label: 'Vehicle VIN',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'vin',
                      }),
                  },
                  {
                    // type: 'text',
                    // field: 'mileage',
                    label: 'Vehicle Mileage',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'mileage',
                      }),
                  },
                  {
                    // type: 'text',
                    // field: 'model',
                    label: 'Vehicle Model',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'model',
                      }),
                  },
                  {
                    // type: 'text',
                    // field: 'year',
                    label: 'Vehicle Year',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'year',
                      }),
                  },
                  {
                    // type: 'text',
                    // field: 'make',
                    label: 'Vehicle Make',
                    render: ({ navigation }) =>
                      checkField({
                        navigation,
                        fieldName: 'make',
                      }),
                  },
                ],
              },
            ],
          },
        ],
      }}
      {...props}
    />
  );
};

export default ViewReport;
